module.exports = __webpack_public_path__ + "static/media/golivro.7e260fed.png";